import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../config/app-config';
import { MyReviewForListDto, ReviewerLevelProgressDto } from '@/app/shared/models/reviews.models';
import { PublicUserProfileDto, UserSearchResultDto, UserStreak } from '@/app/shared/models/users.models';

@Injectable({ providedIn: 'root' })
export class UsersApi {
  private readonly baseUrl = `${AppConfig.apiBaseUrl}/api/me`;
  private readonly apiUrl = `${AppConfig.apiBaseUrl}/api`;

  constructor(private readonly http: HttpClient) {}

  checkUsernameAvailability(username: string): Observable<{ available: boolean }> {
    return this.http.get<{ available: boolean }>(`${this.baseUrl}/username-availability`, {
      params: { username },
    });
  }

  getReviewerLevel(): Observable<ReviewerLevelProgressDto> {
    return this.http.get<ReviewerLevelProgressDto>(`${this.baseUrl}/reviewer-level`);
  }

  updateMyTimeZone(timeZoneId: string): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/time-zone`, { timeZoneId });
  }

  getMyStreak(): Observable<UserStreak> {
    return this.http.get<UserStreak>(`${this.baseUrl}/streak`);
  }

  getPublicProfile(username: string): Observable<PublicUserProfileDto> {
    return this.http.get<PublicUserProfileDto>(`${this.apiUrl}/profiles/${encodeURIComponent(username)}`);
  }

  getPublicUserReviews(username: string): Observable<MyReviewForListDto[]> {
    return this.http.get<MyReviewForListDto[]>(`${this.apiUrl}/profiles/${encodeURIComponent(username)}/reviews`);
  }

  searchUsers(query: string): Observable<UserSearchResultDto[]> {
    return this.http.get<UserSearchResultDto[]>(`${this.apiUrl}/profiles/search`, {
      params: { q: query },
    });
  }
}
